/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiBarberShiftsBooked200, GetApiBarberShiftsBooked400, GetApiBarberShiftsBooked401, GetApiBarberShiftsBooked403, GetApiBarberShiftsBooked404, GetApiBarberShiftsBooked500, GetApiBarberShiftsBookedQueryParams, GetApiBarberShiftsBookedQueryResponse } from "../entities/GetApiBarberShiftsBooked";
import { modelsBookedShiftsOutputSchema } from "./models/bookedShiftsOutputSchema";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { z } from "zod/v4";

export const getApiBarberShiftsBookedQueryParamsSchema = z.object({
    "from": z.string().describe("Дата начала периода"),
"to": z.string().describe("Дата конца периода")
    }) as unknown as z.ZodType<GetApiBarberShiftsBookedQueryParams>

/**
 * @description OK
 */
export const getApiBarberShiftsBooked200Schema = z.lazy(() => modelsBookedShiftsOutputSchema) as unknown as z.ZodType<GetApiBarberShiftsBooked200>

/**
 * @description Bad Request
 */
export const getApiBarberShiftsBooked400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftsBooked400>

/**
 * @description Unauthorized
 */
export const getApiBarberShiftsBooked401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftsBooked401>

/**
 * @description Forbidden
 */
export const getApiBarberShiftsBooked403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftsBooked403>

/**
 * @description Not Found
 */
export const getApiBarberShiftsBooked404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftsBooked404>

/**
 * @description Internal Server Error
 */
export const getApiBarberShiftsBooked500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<GetApiBarberShiftsBooked500>

export const getApiBarberShiftsBookedQueryResponseSchema = z.lazy(() => getApiBarberShiftsBooked200Schema) as unknown as z.ZodType<GetApiBarberShiftsBookedQueryResponse>